// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list__qoe6pAEGvj{width:272px}.item__so_qIIl7d8{display:flex;align-items:center;justify-content:space-between}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/views/queue/components/controls/components/preferences/queueDashboardPreferencesControl.module.scss"],"names":[],"mappings":"AAAA,kBACE,WAAA,CAGF,kBACE,YAAA,CACA,kBAAA,CACA,6BAAA","sourcesContent":[".list {\n  width: 272px;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `list__qoe6pAEGvj`,
	"item": `item__so_qIIl7d8`
};
export default ___CSS_LOADER_EXPORT___;
